import { render, staticRenderFns } from "./CreateCustomFieldModal.vue?vue&type=template&id=6bed4d80&scoped=true"
import script from "./CreateCustomFieldModal.vue?vue&type=script&lang=js"
export * from "./CreateCustomFieldModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomFieldModal.vue?vue&type=style&index=0&id=6bed4d80&prod&lang=scss&rel=stylesheet%2Fscss"
import style1 from "./CreateCustomFieldModal.vue?vue&type=style&index=1&id=6bed4d80&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed4d80",
  null
  
)

export default component.exports